import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';


const typeAPI = createApi({
    reducerPath: "typeAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllTypes: builder.mutation({
            query: ({ size, search }) => {
                let apiUrl = `vehicle/type`;

                if (size) {
                    apiUrl += `?size=${size}`;
                }

                if (search) {
                    apiUrl += `&search=${search}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["type"],
        }),
        createType: builder.mutation({
            query: ({body}) => ({
                url: `vehicle/type`,
                method: "POST",
                body
            }),
            invalidatesTags: ["type"],
        }),
        updateType: builder.mutation({
            query: ({ id, body}) => ({
                url: `vehicle/type/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["type"],
        }),
        deleteType: builder.mutation({
            query: ({id}) => ({
                url: `vehicle/type/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["type"],
        }),
        bulkUploadTypes: builder.mutation({
            query: ({body}) => ({
                url: `vehicle/type/batch`,
                method: "POST",
                body
            }),
            invalidatesTags: ["type"],
        }),
    }),
});

export const {
    useGetAllTypesMutation,
    useCreateTypeMutation,
    useUpdateTypeMutation,
    useDeleteTypeMutation,
    useBulkUploadTypesMutation,
} = typeAPI;

export default typeAPI;